import React from 'react';
import { Box } from '@material-ui/core';
import { TableGroupRow as DevExpressTableGroupRow } from '@devexpress/dx-react-grid-material-ui';
import { TableGroupRow as TableGroupRowBase } from '@devexpress/dx-react-grid';
import clsx from 'clsx';
import useStyles from './TableGroupCell.styles';

interface Props extends TableGroupRowBase.CellProps {
  className?: string;
}

const TableGroupCell: React.FC<Props> = ({
  row,
  tableRow,
  tableColumn,
  column,
  className,
  children,
  ...restProps
}) => {
  const classes = useStyles();

  return (
    <DevExpressTableGroupRow.Cell
      row={row}
      tableRow={tableRow}
      tableColumn={tableColumn}
      column={column}
      {...restProps}
      className={clsx(className, classes.groupCell)}
    >
      <Box component="span" display="inline-flex" alignItems="center">
        <Box className={classes.groupText}>
          <span className={classes.groupTitle}>{`${column?.title}: `}</span>
          {children || row?.key}
        </Box>
      </Box>
    </DevExpressTableGroupRow.Cell>
  );
};

export default TableGroupCell;
